export default __webpack_public_path__ + "static/media/SamlipOutline.cb892823.ttf";